import React from 'react';
import MainLayout from 'layouts/MainLayout';
import {Outlet} from 'react-router-dom';
import CompaniesTable from './CompaniesTable';

const CompaniesPage = () => {
    return (
        <MainLayout>
            <div className="companies">
                <CompaniesTable />
                <Outlet />
            </div>
        </MainLayout>
    )
}

export default CompaniesPage;